<template>
  <div v-if="showLoading" :class="['readonly-text-container', containerClass]">
    <dt :class="labelClass">{{ labelUpperCase ? label.toLocaleUpperCase() : label }}</dt>
    <dd class="mb-0">
      <Skeleton :style="{ width: '100%', height: '1.75rem' }" :aria-label="`Loading ${label}`" />
    </dd>
  </div>
  <div v-else :class="['readonly-text-container', containerClass]">
    <dt :class="labelClass">{{ labelUpperCase ? label.toLocaleUpperCase() : label }}</dt>
    <dd :class="['mb-0', contentClass]">
      <slot name="content">
        <span v-if="value" v-html="sanitizeValue(value)"></span>
        <span v-else>-</span>
      </slot>
    </dd>
  </div>
</template>

<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core


// Components
import Skeleton from 'primevue/skeleton';

// Composables


// Stores


// Constants and Utils
import { sanitizeHTML } from '@/utils/dataUtils';

// ===============================
// PROPS & EMITS
// ===============================
defineProps({
    label: {
        type: String,
        default: ''
    },
    value: {
        type: [String, Number, Date, null],
        default: ''
    },
    showLoading: {
        type: Boolean,
        default: false
    },
    containerClass: {
        type: String,
        default: ''
    },
    contentClass: {
        type: String,
        default: 'fs-5'
    },
    labelClass: {
        type: String,
        default: 'label-text'
    },
    labelUpperCase: {
        type: Boolean,
        default: true
    }
});

// ===============================
// COMPOSABLES & STORES
// ===============================


// ===============================
// REACTIVE STATE
// ===============================


// ===============================
// CONSTANTS
// ===============================


// ===============================
// COMPUTED PROPERTIES
// ===============================


// ===============================
// METHODS
// ===============================
const sanitizeValue = (value) => {
  let stringValue;
  
  // Convert number to string
  if (typeof value === 'number') {
    stringValue = String(value);
  }
  // Convert Date to string
  else if (value instanceof Date) {
    stringValue = value.toLocaleDateString();
  }
  // Already a string
  else {
    stringValue = value;
  }
  
  // Apply HTML sanitization
  return sanitizeHTML(stringValue);
};

// ===============================
// WATCHERS
// ===============================


// ===============================
// LIFECYCLE HOOKS
// ===============================


// ===============================
// EXPOSE
// ===============================


</script>

<style>
.readonly-text-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
</style>